export type PayParams = {
  appid: string;
  noncestr: string;
  package: string;
  partnerid: string;
  prepayid: string;
  sign: string;
  timestamp: string;
};

/**
 * 分享类型
 * * text: 文本
 * * image: 图片
 * * link: 链接
 * * miniProgram: 小程序
 */
export type ShareType = 'text' | 'image' | 'link' | 'miniProgram';

/**
 * 微信分享参数
 */
export type ShareParams = {
  /**
   * 分享类型
   * * text: 文本
   * * image: 图片
   * * link: 链接
   * * miniProgram: 小程序
   */
  type: ShareType;
  /**
   * 分享标题（链接/小程序需要）
   *
   * 限制长度不超过 512Bytes
   */
  title?: string;
  /**
   * 分享描述（文本/链接需要）
   *
   * 限制长度不超过 1KB
   */
  description?: string;
  /**
   * 链接分享的目标URL（链接类型需要）
   */
  url?: string;
  /**
   * 缩略图路径（本地文件路径或网络URL）
   * * 图片不超过 32KB
   */
  thumbPath?: string;
  /**
   * 图片路径（本地文件路径或网络URL，图片类型需要）
   */
  imagePath?: string;
  /**
   * 小程序原始ID（小程序类型需要）
   */
  miniProgramId?: string;
  /**
   * 小程序页面路径（小程序类型需要）
   */
  miniProgramPath?: string;
  /**
   * 分享场景（会话/朋友圈/收藏）
   *
   * * 会话：session
   * * 朋友圈：timeline
   * * 收藏：favorite
   */
  scene: 'session' | 'timeline' | 'favorite';
};

export interface JustWeiWechatPlugin {
  echo(options: { value: string }): Promise<{ value: string }>;
  registerWx(): void;
  authLogin(): Promise<any>;
  pay(payParams: PayParams): Promise<{ payResult: string }>;
  share(shareParams: ShareParams): Promise<{ result: 'success' | 'cancel' | 'denied' | 'fail' }>;
}
